import React from 'react';
import PropTypes from 'prop-types';
import {
  CardMedia,
  Card,
  Typography,
  CardTitle,
  CardActions,
  Button,
  CardBody
} from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import ProjectsHeader from '../ProjectsHeader';
import NullStateCreateProjectAction from './NullStateCreateProjectAction';
import nullStateConstants from '../../constants/nullStateConstants';
import {
  triggerProjectsInteractionAnalytics,
} from '../../utils/helpers';

const DesktopNullView = ({
  componentId
}) => {
  const {
    cardTitle,
    bodyText,
    imageAlt,
    imageUrl,
    buttonTextDesktop,
    learnMoreText,
  } = nullStateConstants;

  return (
    <div
      data-component="Projects"
      data-testid="projects-null-container"
    >
      {/* Contains main content + image to right */}
      <div className="sui-flex sui-gap-4 sui-h-full">
        {/* Contains everything except image */}
        <div
          className={classNames(
            'sui-flex',
            'sui-flex-col',
            'sui-gap-4',
            'sui-h-full',
            'sui-min-w-64',
            'sui-w-full'
          )}
        >
          <ProjectsHeader
            hideActions
            componentId={componentId}
          />
          <div
            className="sui-flex sui-flex-col sui-gap-4 sui-justify-between sui-h-full"
          >
            <div
              className="sui-flex sui-flex-col sui-gap-1"
            >
              <CardTitle
                headerVariant="h3"
                headerWeight="display"
                header={<span style={{ whiteSpace: 'pre-line' }}>{cardTitle}</span>}
              />
              <CardBody>
                <div className="sui-pr-10">
                  <Typography>{bodyText}</Typography>
                </div>
              </CardBody>
            </div>

            <CardActions className="sui-flex sui-flex-row sui-gap-4">
              <div className="sui-w-full">
                <Button
                  fullWidth
                  variant="secondary"
                  href={nullStateConstants.learnMoreLink}
                  onClick={() => triggerProjectsInteractionAnalytics({
                    action: 'button-click',
                    id: componentId,
                    component: 'learn more',
                  })}
                >{learnMoreText}
                </Button>
              </div>

              <div className="sui-w-full">
                <NullStateCreateProjectAction
                  cacheKey="desktop-null-view-create-project"
                  componentId={componentId}
                  buttonText={buttonTextDesktop}
                />
              </div>
            </CardActions>
          </div>
        </div>
        <div className="sui-w-full">
          <CardMedia
            src={imageUrl}
            alt={imageAlt}
            className={classNames(
              'sui-w-full',
              'sui-h-full',
              'sui-transform',
              'sui-object-cover',
              'sui-object-center'
            )}
          />
        </div>
      </div>
    </div>

  );
};

DesktopNullView.propTypes = {
  componentId: PropTypes.string,
};
DesktopNullView.defaultProps = {
  componentId: '',
};
export default DesktopNullView;
